// src/pages/Enterprise/FormWizardTesting.jsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import Select from "react-select";
import classnames from "classnames";
// import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { loadAnimation } from "lottie-web";
import { defineElement } from "lord-icon-element";
import Swal from "sweetalert2";
import { FaArrowLeft, FaCheck, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

defineElement(loadAnimation);

const FormWizardTesting = () => {
  const navigate = useNavigate();

  // ---------------- Tabs ----------------
  const [activeVerticalTab, setactiveVerticalTab] = useState(7);
  const [passedverticalSteps, setPassedverticalSteps] = useState([1]);
  function toggleVerticalTab(tab) {
    if (activeVerticalTab !== tab) {
      const modifiedSteps = [...passedverticalSteps, tab];
      if (tab >= 7 && tab <= 12) {
        setactiveVerticalTab(tab);
        setPassedverticalSteps(modifiedSteps);
      }
    }
  }
  // ---------------- User / Role (STEP 1) ----------------
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [users, setUsers] = useState([]);
  const [allUsersData, setAllUsersData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");

  const authUserString = sessionStorage.getItem("authUserData1");
  const authUser = JSON.parse(authUserString);
  const UserId = authUser?.data[0]?.id;
  const UserRole = authUser?.data[0]?.role;
  const userRoleValue  = authUser?.data[0]?.role === 2 ? "Company": "-" || {};
  const UserCode = authUser?.data[0]?.org_code;
  const UserName = authUser?.data[0]?.business_name;


  const fetchRoles = useCallback(async () => {
    try {
      const response = await fetch("https://spillas.com/api/v1/org_user/roles");
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      // original filter kept: Retailers only
      const filteredRoles = data.filter((role) => role.name === "Retailers");
      setRoles(filteredRoles);
    } catch (error) {
      console.error("Could not fetch roles:", error);
    }
  }, []);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  const fetchUsersByRole = useCallback(
    async (roleId) => {
      if (roleId) {
        let apiRoleId;
        const foundRole = roles.find((role) => role.id === parseInt(roleId));
        if (foundRole?.name?.toLowerCase() === "retailers") apiRoleId = 7;
        else if (foundRole?.name?.toLowerCase() === "company") apiRoleId = 2;

        if (apiRoleId) {
          try {
            const response = await fetch(
              // original endpoint you used (kept)
              `https://spillas.com/api/v1/org_user?role=5&per_page=10000000000`
            );
            const data = await response.json();
            if (data && data.data) {
              setAllUsersData(data.data);
              const formattedUsers = data.data.map((user) => ({
                value: user.id,
                label: `${user.org_code} - ${user.business_name}`,
              }));
              setUsers(formattedUsers);
            } else {
              setUsers([]);
              setAllUsersData([]);
            }
          } catch (error) {
            console.error("Error fetching users:", error);
            setUsers([]);
            setAllUsersData([]);
          }
        } else {
          setUsers([]);
          setAllUsersData([]);
        }
      } else {
        setUsers([]);
        setAllUsersData([]);
      }
    },
    [roles]
  );

  const handleRoleChange = (e) => {
    const roleId = e.target.value;
    setSelectedRole(roleId);
    setSelectedUser(null);
    setSelectedUserDetails(null);
    fetchUsersByRole(roleId);
  };

  const handleUserChange = (selectedOption) => {
    setSelectedUser(selectedOption);
    if (selectedOption) {
      const foundUser = allUsersData.find((user) => user.id === selectedOption.value);
      setSelectedUserDetails(foundUser);
    } else {
      setSelectedUserDetails(null);
    }
  };

  // ---------------- JSON Upload / Create Enterprise (STEP 2) ----------------
  const [selectedFile, setSelectedFile] = useState(null);
  const [signupUrl, setSignupUrl] = useState("");
  const [signupUrlName, setSignupUrlName] = useState("");
  const [enterpriseToken, setEnterpriseToken] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [isCreatingEnterprise, setIsCreatingEnterprise] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [createEnterpriseError, setCreateEnterpriseError] = useState(null);
  const [isUploadEnabled, setIsUploadEnabled] = useState(false);
  const [isCreateEnterpriseEnabled, setIsCreateEnterpriseEnabled] = useState(false);
  const [isCreatePoliciesEnabled, setIsCreatePoliciesEnabled] = useState(false);
  const fileInputRef = useRef(null);
  const [enterpriseId, setEnterpriseId] = useState("");
  console.log("enterprise ID: ", enterpriseId)

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsUploadEnabled(event.target.files[0] !== null);
  };

  const handleUploadClick = async () => {
    if (!selectedFile) {
      Swal.fire("Error", "Please select a JSON file first.", "error");
      return;
    }

    const formData = new FormData();
    formData.append("jsonFile", selectedFile);

    setIsUploading(true);
    setUploadError(null);
    setIsUploadEnabled(false);

    Swal.fire({
      title: "Uploading JSON details...",
      html:
        '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div><div class="mt-2">Please wait while the JSON data is being uploaded.</div>',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    try {
      const response = await fetch("https://spillas.com:3055/signup", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `HTTP error! status: ${response.status}, message: ${errorData?.message || "Something went wrong"}`
        );
      }

      const responseData = await response.json();
      setSignupUrl(responseData.signupUrl);
      setSignupUrlName(responseData.signupUrlName);
      setIsCreateEnterpriseEnabled(true);
      Swal.fire("Success", "JSON details uploaded successfully!", "success");
    } catch (error) {
      console.error("File upload failed:", error);
      setUploadError(error.message);
      Swal.fire("Error", `File upload failed: ${error.message}`, "error");
      setIsUploadEnabled(true);
      setIsCreateEnterpriseEnabled(false);
    } finally {
      setIsUploading(false);
      Swal.close();
    }
  };

  const handleTokenChange = (event) => setEnterpriseToken(event.target.value);

  const handleCopyClick = () => {
    if (signupUrl) {
      navigator.clipboard.writeText(signupUrl);
      Swal.fire("Success", "Signup URL copied to clipboard!", "success");
    } else {
      Swal.fire("Info", "No Signup URL to copy.", "info");
    }
  };

  const handleCreateEnterprise = async () => {
    if (!selectedFile) return Swal.fire("Warning", "Please upload a JSON file first.", "warning");
    if (!signupUrlName) return Swal.fire("Warning", "Signup URL Name is required.", "warning");
    if (!enterpriseToken) return Swal.fire("Warning", "Enterprise Token is required.", "warning");

    setIsCreatingEnterprise(true);
    setCreateEnterpriseError(null);
    setIsCreateEnterpriseEnabled(false);

    Swal.fire({
      title: "Creating Enterprise...",
      html:
        '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div><div class="mt-2">Please wait while the enterprise is being created.</div>',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    const formData = new FormData();
    formData.append("jsonFile", selectedFile);
    formData.append("signupUrlName", signupUrlName);
    formData.append("enterpriseToken", enterpriseToken);

    try {
      const response = await fetch("https://spillas.com:3055/createEnterprise", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `HTTP error! status: ${response.status}, message: ${errorData?.message || "Something went wrong"}`
        );
      }

      const responseData = await response.json();

      if (responseData?.enterprise?.name) {
        const extractedId = responseData.enterprise.name.split("/").pop();
        setEnterpriseId(extractedId);
      }

      Swal.fire("Success", "Enterprise Created successfully!", "success").then(() => {
        setIsCreatePoliciesEnabled(true);
      });
    } catch (error) {
      console.error("Create Enterprise API failed:", error);
      setCreateEnterpriseError(error.message);
      Swal.fire("Error", `Failed to create enterprise: ${error.message}`, "error");
      setIsCreateEnterpriseEnabled(true);
      setIsCreatePoliciesEnabled(false);
    } finally {
      setIsCreatingEnterprise(false);
      Swal.close();
    }
  };

  // ---------------- Policies (STEP 3) ----------------
  const [policyCreationStatus, setPolicyCreationStatus] = useState({});
  const policies = [
    "LockDevice",
    "hardlock",
    "UnlockDevice",
    "UnistallDevice",
    "UnistallDevice",
    "goexzerotouch",
    "DisableApp",
    "goexzerotouch",
    "unlockusb",
    "goexzerotouch",
    "developer_option_on",
    "goexzerotouch",
    "goexzerotouch",
    "outGoingOff",
    "goexzerotouch",
    "cameraOff",
  ];

  const createPolicy = async (policyName) => {
    if (!selectedFile || !enterpriseId) {
      console.warn("Selected file or Enterprise ID is missing for policy creation.");
      return;
    }

    const formData = new FormData();
    formData.append("enterpriseId", enterpriseId);
    formData.append("policyName", policyName);
    formData.append("jsonFile", selectedFile);
    formData.append("orgId", 26);

    try {
      const response = await fetch("https://spillas.com:3055/createPolicy", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Failed to create policy ${policyName}: ${response.status} - ${errorData?.message || "Something went wrong"}`
        );
      }

      const responseData = await response.json();
      if (responseData?.policy?.name?.includes(policyName)) {
        setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: true }));
      } else {
        setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: false }));
        console.warn(`Policy name in response does not match "${policyName}"`);
      }
    } catch (error) {
      console.error(`Error creating policy "${policyName}":`, error);
      setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: false }));
      Swal.fire("Error", `Failed to create policy "${policyName}": ${error.message}`, "error");
    }
  };

  const handleNextTab = () => {
    toggleVerticalTab(activeVerticalTab + 1);
    policies.forEach((p) => createPolicy(p));
  };

  // ---------------- Create Enrollment Token (STEP 4) ----------------
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [enrollmentToken, setEnrollmentToken] = useState("");

  const handleNextTabFromPolicy = async () => {
    if (!selectedFile || !enterpriseId) {
      Swal.fire("Warning", "Please ensure a file is uploaded and the enterprise is created.", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("enterpriseId", enterpriseId);
    formData.append("jsonFile", selectedFile);

    try {
      const response = await fetch("https://spillas.com:3055/createEnrollmentToken", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Failed to create enrollment token: ${response.status} - ${errorData?.message || "Something went wrong"}`
        );
      }

      const responseData = await response.json();
      setQrCodeUrl(responseData.qrCodeUrl);
      setEnrollmentToken(responseData.enrollmentToken);
      Swal.fire("Success", "Enrollment Token created successfully!", "success");
      toggleVerticalTab(activeVerticalTab + 1);
    } catch (error) {
      console.error("Error creating enrollment token:", error);
      Swal.fire("Error", `Failed to create enrollment token: ${error.message}`, "error");
    }
  };

  // ---------------- Assign Enterprise (STEP 5) ----------------
  const [assignEnterpriseResponse, setAssignEnterpriseResponse] = useState("");

  const assignEnterprise = async (setDefault) => {
    if (!enterpriseId || !UserId || !UserRole) {
      Swal.fire("Warning", "Please ensure enterprise, user, and role are selected.", "warning");
      return;
    }

    const payload = {
      enterprise_name: enterpriseId,
      retailer_code: "RTL70" || "",
      retailer_id: 70 || "",
      json_path: `public/storage/public/json/${enterpriseId}.json`,
      default_enterprise: setDefault ? 1 : 0,
      qr_url: `public/storage/public/qr/${enterpriseId}.png`,
      entprise_type: 5,
      company_id: 70 || "",
      company_name: UserName || "",
      zresellerid: "ZR01",
      zconfigid: "ZC01",
      zcompanyid: "ZCOMP01",
      role: UserRole,
      email,
      mobile,
      password,
    };

    try {
      const response = await fetch("https://spillas.com:3055/add-enterprise-to-db", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Failed: ${response.status} - ${errorData?.message || "Something went wrong"}`);
      }

      const responseData = await response.json();
      setAssignEnterpriseResponse(responseData.message || "Enterprise added successfully!");
      Swal.fire("Success", responseData.message || "Enterprise added successfully!", "success");
      toggleVerticalTab(activeVerticalTab + 1);
    } catch (error) {
      console.error("Error assigning enterprise:", error);
      Swal.fire("Error", `Failed to assign enterprise: ${error.message}`, "error");
    }
  };

  const handleAssignEnterpriseConfirmation = (setDefault) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to assign this enterprise.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, assign it!",
    }).then((result) => {
      if (result.isConfirmed) assignEnterprise(setDefault);
    });
  };

  const handleSetProvisioningConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to set this enterprise as provisioning.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, set provisioning!",
    }).then((result) => {
      if (result.isConfirmed) assignEnterpriseProvisioning();
    });
  };

  const assignEnterpriseProvisioning = async () => {
    if (!enterpriseId || !UserId || !UserRole) {
      Swal.fire("Warning", "Please ensure enterprise, user, and role are selected.", "warning");
      return;
    }

    const payload = {
      enterprise_name: enterpriseId,
      retailer_code: UserCode || "",
      retailer_id: UserId || "",
      json_path: `public/storage/public/json/${enterpriseId}.json`,
      default_enterprise: 2, // <-- provisioning
      qr_url: `public/storage/public/qr/${enterpriseId}.png`,
      entprise_type: "SELF",
      company_id: UserId || "",
      company_name: UserName || "",
      zresellerid: "ZR01",
      zconfigid: "ZC01",
      zcompanyid: "ZCOMP01",
      role: UserRole,
      email,
      mobile,
      password,
    };

    try {
      const response = await fetch("https://spillas.com:3055/add-enterprise-to-db", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Failed: ${response.status} - ${errorData?.message || "Something went wrong"}`);
      }

      const responseData = await response.json();
      setAssignEnterpriseResponse(responseData.message || "Enterprise set as provisioning!");
      Swal.fire("Success", responseData.message || "Enterprise set as provisioning!", "success");
      toggleVerticalTab(activeVerticalTab + 1);
    } catch (error) {
      console.error("Error setting provisioning:", error);
      Swal.fire("Error", `Failed to set provisioning: ${error.message}`, "error");
    }
  };

  // ---------------- UI ----------------
  document.title = "Wizard | R.R. Technology";

  // Memoized helper components to prevent remounts and keep input focus stable
  const InputTW = useCallback((props) => {
    return (
      <input
        {...props}
        className={
          "w-full rounded-xl border border-zinc-200 px-3 py-2 text-sm outline-none placeholder:text-zinc-400 focus:border-blue-300 focus:ring-2 focus:ring-blue-200 " +
          (props.className || "")
        }
      />
    );
  }, []);

  const LabelTW = useCallback(({ children, htmlFor }) => {
    return (
      <label htmlFor={htmlFor} className="block text-sm font-medium text-zinc-700 mb-1">
        {children}
      </label>
    );
  }, []);

  const SectionCard = useCallback(({ title, children }) => {
    return (
      <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
        {title ? (
          <div className="border-b border-zinc-200 bg-blue-50/60 px-4 py-3">
            <h3 className="text-sm font-semibold text-blue-800">{title}</h3>
          </div>
        ) : null}
        <div className="p-4">{children}</div>
      </section>
    );
  }, []);

  const ButtonTW = useCallback(({ children, variant = "primary", type = "button", ...rest }) => {
    const map = {
      primary: "bg-blue-600 hover:bg-blue-500 text-white",
      success: "bg-emerald-600 hover:bg-emerald-500 text-white",
      danger: "bg-rose-600 hover:bg-rose-500 text-white",
      secondary: "bg-zinc-100 hover:bg-zinc-200 text-zinc-800",
    };

    return (
      <button
        type={type}
        {...rest}
        className={
          "rounded-xl px-4 py-2 text-sm font-medium transition focus:outline-none focus:ring-2 " +
          (variant === "primary"
            ? "focus:ring-blue-200"
            : variant === "success"
            ? "focus:ring-emerald-200"
            : variant === "danger"
            ? "focus:ring-rose-200"
            : "focus:ring-zinc-200") +
          " " +
          map[variant]
        }
      >
        {children}
      </button>
    );
  }, []);

  // step helper depends on activeVerticalTab and setactiveVerticalTab
  const step = useCallback(
    (tabNumber, label) => {
      const isActive = activeVerticalTab === tabNumber;
      const isDone = activeVerticalTab <= 12 && activeVerticalTab >= tabNumber;

      return (
        <div
          key={tabNumber}
          className={`flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer
            ${isActive ? "bg-blue-600 text-white" : ""}
            ${!isActive && isDone ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}
          `}
          // onClick={() => setactiveVerticalTab(tabNumber)}
        >
          <i
            className={`ri-close-circle-fill step-icon
              ${isActive ? "text-white" : isDone ? "text-green-600" : "text-gray-400"}
            `}
          ></i>
          <span className="font-medium">Step {tabNumber - 6}</span>
          <span>{label}</span>
        </div>
      );
    },
    [activeVerticalTab]
  );

  return (
    <div className="min-h-screen bg-white text-zinc-900">
      {/* Header / Breadcrumb */}
      <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4 py-4">
          {/* <BreadCrumb title="Forms" breadcrumbItem="Wizard" /> */}
          <h1 className="mt-1 text-xl font-semibold tracking-tight">CREATE ENTERPRISE</h1>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6">
        <SectionCard>
          <div className="pt-3 pb-3">
            <button
              className="bg-blue-500 hover:bg-blue-400 cursor-pointer text-white px-2 py-1 rounded-md flex items-center gap-1"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeft /> Go Back
            </button>
          </div>
          <form className="w-full">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              {/* Left: Steps */}
              <div className="col-span-12 md:col-span-4 lg:col-span-3">
                <div className="flex flex-col gap-2">
                  {step(7, "Select User")}
                  {step(8, "Upload Json")}
                  {step(9, "Create Policies")}
                  {step(10, "Create QR")}
                  {step(11, "Set as Default")}
                </div>
              </div>

              {/* Right: Content */}
              <div className="col-span-12 md:col-span-8 lg:col-span-9">
                {/* STEP 1 */}
                <div style={{ display: activeVerticalTab === 7 ? "block" : "none" }}>
                  <SectionCard title="Step 1 — Select User">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Role Selection */}
                      <div>
                        <LabelTW htmlFor="keyType">Select Role</LabelTW>
                        {/* <select
                          id="keyType"
                          value={selectedRole}
                          onChange={handleRoleChange}
                          className="w-full rounded-xl border border-zinc-200 bg-white px-3 py-2 text-sm outline-none focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
                        >
                          <option value="">Select Role</option>
                          {roles.map((role) => (
                            <option key={role.id} value={role.id}>
                              {role.name}
                            </option>
                          ))}
                        </select> */}
                       <InputTW id="text" type="text" value={userRoleValue} placeholder="User Role" />
                      </div>

                      {/* User Selection */}
                      <div>
                        <LabelTW htmlFor="user">Select User</LabelTW>
                        {/* <Select
                          id="user"
                          options={users}
                          value={selectedUser}
                          onChange={handleUserChange}
                          isDisabled={!selectedRole}
                          placeholder="Search for a User"
                          isSearchable
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              minHeight: "40px",
                              borderColor: state.isFocused ? "#86b7fe" : "#e4e4e7",
                              boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(37,99,235,.15)" : "none",
                            }),
                          }}
                        /> */}
                        <InputTW id="text" type="text" value={authUser?.data[0]?.business_name} placeholder="User Role" />
                      </div>
                    </div>

                    {/* Selected User Details */}
                    {selectedUserDetails && (
                      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                        <div>
                          <div className="text-zinc-500">Code</div>
                          <div className="font-medium">{selectedUserDetails.org_code}</div>
                        </div>
                        <div>
                          <div className="text-zinc-500">Name</div>
                          <div className="font-medium">{selectedUserDetails.business_name}</div>
                        </div>
                        <div>
                          <div className="text-zinc-500">Email</div>
                          <div className="font-medium">{selectedUserDetails.email}</div>
                        </div>
                        <div>
                          <div className="text-zinc-500">Phone</div>
                          <div className="font-medium">{selectedUserDetails.mobile}</div>
                        </div>
                      </div>
                    )}

                    {/* Inputs */}
                    <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <LabelTW htmlFor="email">Email</LabelTW>
                        <InputTW id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter email" />
                      </div>
                      <div>
                        <LabelTW htmlFor="password">Password</LabelTW>
                        <InputTW id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" />
                      </div>
                      <div>
                        <LabelTW htmlFor="mobile">Mobile Number</LabelTW>
                        <InputTW id="mobile" type="tel" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Enter mobile number" />
                      </div>
                    </div>

                    <div className="mt-5 flex justify-end">
                      <ButtonTW
                        variant="success"
                        onClick={() => toggleVerticalTab(activeVerticalTab + 1)}
                        disabled={!UserRole || !UserName   || !email || !password || !mobile}
                      >
                        Next
                      </ButtonTW>
                    </div>
                  </SectionCard>
                </div>

                {/* STEP 2 */}
                <div style={{ display: activeVerticalTab === 8 ? "block" : "none" }}>
                  <SectionCard title="Step 2 — Upload Json & Create Enterprise">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
                      <div className="md:col-span-2">
                        <LabelTW>Upload JSON</LabelTW>
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                          <input ref={fileInputRef} type="file" accept=".json" onChange={handleFileChange} className="hidden" id="jsonUpload" />
                          <label htmlFor="jsonUpload" className="flex-1 cursor-pointer rounded-xl border border-zinc-200 px-3 py-2 text-sm text-zinc-600 bg-white w-full">
                            {selectedFile ? selectedFile.name : "Choose file..."}
                          </label>
                          <button type="button" onClick={handleUploadClick} disabled={!selectedFile} className="rounded-xl bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-500 disabled:bg-zinc-400">
                            Upload JSON
                          </button>
                        </div>
                        {uploadError && <p className="text-rose-600 text-sm mt-2">{uploadError}</p>}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end mt-4">
                      <div className="md:col-span-2">
                        <LabelTW>Signup URL</LabelTW>
                        <InputTW value={signupUrl} readOnly placeholder="Signup URL will appear here..." />
                      </div>
                      <div className="flex">
                        <ButtonTW variant="success" onClick={handleCopyClick} disabled={!signupUrl}>
                          Copy
                        </ButtonTW>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
                      <div className="md:col-span-2">
                        <LabelTW>Signup URL Name</LabelTW>
                        <InputTW value={signupUrlName} readOnly placeholder="Signup URL Name will appear here..." />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end mt-4">
                      <div className="md:col-span-2">
                        <LabelTW>Enterprise Token</LabelTW>
                        <InputTW placeholder="Paste Token Here..." value={enterpriseToken} onChange={handleTokenChange} />
                      </div>
                      <div className="flex">
                        <ButtonTW
                          variant="success"
                          onClick={handleCreateEnterprise}
                          disabled={isCreatingEnterprise || !signupUrlName || !enterpriseToken || !selectedFile || !isCreateEnterpriseEnabled}
                        >
                          Create Enterprise
                        </ButtonTW>
                      </div>
                    </div>

                    <div className="mt-5 flex justify-end">
                      <ButtonTW variant="success" onClick={handleNextTab} disabled={!isCreatePoliciesEnabled}>
                        Next
                      </ButtonTW>
                    </div>

                    {createEnterpriseError && <div className="text-rose-600 text-sm mt-2">{createEnterpriseError}</div>}
                  </SectionCard>
                </div>

                {/* STEP 3 */}
                <div style={{ display: activeVerticalTab === 9 ? "block" : "none" }}>
                  <SectionCard title="Step 3 — Create Policies">
                    <ul className="space-y-2">
                      {policies.map((policy) => (
                        <li key={policy} className="flex items-center gap-2">
                          {policyCreationStatus[policy] === true ? (
                            <i className="ri-checkbox-circle-fill text-emerald-600 text-lg" />
                          ) : policyCreationStatus[policy] === false ? (
                            <i className="ri-close-circle-fill text-rose-600 text-lg" />
                          ) : (
                            <i className="ri-time-line text-amber-500 text-lg" />
                          )}
                          <span className="text-sm">{policy}</span>
                        </li>
                      ))}
                    </ul>

                    <div className="mt-5 flex justify-end">
                      <ButtonTW variant="success" onClick={handleNextTabFromPolicy} disabled={!isCreatePoliciesEnabled}>
                        Next
                      </ButtonTW>
                    </div>
                  </SectionCard>
                </div>

                {/* STEP 4 */}
                <div style={{ display: activeVerticalTab === 10 ? "block" : "none" }}>
                  <SectionCard title="Step 4 — Create QR">
                    <div className="flex flex-col items-center justify-center py-4">
                      {qrCodeUrl ? (
                        <img src={qrCodeUrl} alt="QR Code" className="w-[200px] sm:w-[250px] h-auto object-contain rounded-xl border border-zinc-200" />
                      ) : (
                        <p className="text-sm text-zinc-500">QR Code will appear here after successful creation.</p>
                      )}
                    </div>

                    <div className="flex flex-col sm:flex-row justify-end gap-2">
                      <ButtonTW variant="success" onClick={() => handleAssignEnterpriseConfirmation(false)} disabled={!qrCodeUrl}>
                        Save & Continue
                      </ButtonTW>
                      <ButtonTW variant="success" onClick={() => handleAssignEnterpriseConfirmation(true)} disabled={!qrCodeUrl}>
                        Set as Default
                      </ButtonTW>
                      <ButtonTW variant="secondary" onClick={handleSetProvisioningConfirmation} disabled={!qrCodeUrl}>
                        Set Provisioning
                      </ButtonTW>
                    </div>
                  </SectionCard>
                </div>

                {/* STEP 5 */}
                <div style={{ display: activeVerticalTab === 11 ? "block" : "none" }}>
                  <SectionCard title="Step 5 — Completed">
                    <div className="text-center py-6">
                      <div className="mb-4">
                        <lord-icon src="https://cdn.lordicon.com/lupuorrc.json" trigger="loop" colors="primary:#0ab39c,secondary:#405189" style={{ width: "120px", height: "120px" }}></lord-icon>
                      </div>
                      <h5 className="text-lg font-semibold">Your Enterprise is Completed!</h5>
                      <p className="text-sm text-zinc-600 mt-1">{assignEnterpriseResponse}</p>
                    </div>
                  </SectionCard>
                </div>
              </div>
            </div>
          </form>
        </SectionCard>
      </main>
    </div>
  );
};

export default FormWizardTesting;



// // src/pages/Enterprise/FormWizardTesting.jsx
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import Select from "react-select";
// import classnames from "classnames";
// // import BreadCrumb from "../../../Components/Common/BreadCrumb";
// import { loadAnimation } from "lottie-web";
// import { defineElement } from "lord-icon-element";
// import Swal from "sweetalert2";
// import { FaArrowLeft, FaCheck, FaTimes } from "react-icons/fa";
// import { Link, useNavigate } from "react-router-dom";

// defineElement(loadAnimation);

// const FormWizardTesting = () => {
//   const navigate = useNavigate();

//   // ---------------- Tabs ----------------
//   const [activeVerticalTab, setactiveVerticalTab] = useState(7);
//   const [passedverticalSteps, setPassedverticalSteps] = useState([1]);
//   function toggleVerticalTab(tab) {
//     if (activeVerticalTab !== tab) {
//       const modifiedSteps = [...passedverticalSteps, tab];
//       if (tab >= 7 && tab <= 12) {
//         setactiveVerticalTab(tab);
//         setPassedverticalSteps(modifiedSteps);
//       }
//     }
//   }

//   // ---------------- User / Role (STEP 1) ----------------
//   const [roles, setRoles] = useState([]);
//   const [selectedRole, setSelectedRole] = useState("");
//   const [users, setUsers] = useState([]);
//   const [allUsersData, setAllUsersData] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [selectedUserDetails, setSelectedUserDetails] = useState(null);

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobile, setMobile] = useState("");

//   const fetchRoles = useCallback(async () => {
//     try {
//       const response = await fetch("https://spillas.comapi/v1/org_user/roles");
//       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//       const data = await response.json();
//       // original filter kept: Retailers only
//       const filteredRoles = data.filter((role) => role.name === "Retailers");
//       setRoles(filteredRoles);
//     } catch (error) {
//       console.error("Could not fetch roles:", error);
//     }
//   }, []);

//   useEffect(() => {
//     fetchRoles();
//   }, [fetchRoles]);

//   const fetchUsersByRole = useCallback(
//     async (roleId) => {
//       if (roleId) {
//         let apiRoleId;
//         const foundRole = roles.find((role) => role.id === parseInt(roleId));
//         if (foundRole?.name?.toLowerCase() === "retailers") apiRoleId = 7;
//         else if (foundRole?.name?.toLowerCase() === "company") apiRoleId = 2;

//         if (apiRoleId) {
//           try {
//             const response = await fetch(
//               // original endpoint you used (kept)
//               `https://spillas.comapi/v1/org_user?role=5&per_page=10000000000`
//             );
//             const data = await response.json();
//             if (data && data.data) {
//               setAllUsersData(data.data);
//               const formattedUsers = data.data.map((user) => ({
//                 value: user.id,
//                 label: `${user.org_code} - ${user.business_name}`,
//               }));
//               setUsers(formattedUsers);
//             } else {
//               setUsers([]);
//               setAllUsersData([]);
//             }
//           } catch (error) {
//             console.error("Error fetching users:", error);
//             setUsers([]);
//             setAllUsersData([]);
//           }
//         } else {
//           setUsers([]);
//           setAllUsersData([]);
//         }
//       } else {
//         setUsers([]);
//         setAllUsersData([]);
//       }
//     },
//     [roles]
//   );

//   const handleRoleChange = (e) => {
//     const roleId = e.target.value;
//     setSelectedRole(roleId);
//     setSelectedUser(null);
//     setSelectedUserDetails(null);
//     fetchUsersByRole(roleId);
//   };

//   const handleUserChange = (selectedOption) => {
//     setSelectedUser(selectedOption);
//     if (selectedOption) {
//       const foundUser = allUsersData.find((user) => user.id === selectedOption.value);
//       setSelectedUserDetails(foundUser);
//     } else {
//       setSelectedUserDetails(null);
//     }
//   };

//   // ---------------- JSON Upload / Create Enterprise (STEP 2) ----------------
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [signupUrl, setSignupUrl] = useState("");
//   const [signupUrlName, setSignupUrlName] = useState("");
//   const [enterpriseToken, setEnterpriseToken] = useState("");
//   const [isUploading, setIsUploading] = useState(false);
//   const [isCreatingEnterprise, setIsCreatingEnterprise] = useState(false);
//   const [uploadError, setUploadError] = useState(null);
//   const [createEnterpriseError, setCreateEnterpriseError] = useState(null);
//   const [isUploadEnabled, setIsUploadEnabled] = useState(false);
//   const [isCreateEnterpriseEnabled, setIsCreateEnterpriseEnabled] = useState(false);
//   const [isCreatePoliciesEnabled, setIsCreatePoliciesEnabled] = useState(false);
//   const fileInputRef = useRef(null);
//   const [enterpriseId, setEnterpriseId] = useState("");

//   const handleFileChange = (event) => {
//     setSelectedFile(event.target.files[0]);
//     setIsUploadEnabled(event.target.files[0] !== null);
//   };

//   const handleUploadClick = async () => {
//     if (!selectedFile) {
//       Swal.fire("Error", "Please select a JSON file first.", "error");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("jsonFile", selectedFile);

//     setIsUploading(true);
//     setUploadError(null);
//     setIsUploadEnabled(false);

//     Swal.fire({
//       title: "Uploading JSON details...",
//       html:
//         '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div><div class="mt-2">Please wait while the JSON data is being uploaded.</div>',
//       showConfirmButton: false,
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//     });

//     try {
//       const response = await fetch("https://spillas.com:3055/signup", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `HTTP error! status: ${response.status}, message: ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();
//       setSignupUrl(responseData.signupUrl);
//       setSignupUrlName(responseData.signupUrlName);
//       setIsCreateEnterpriseEnabled(true);
//       Swal.fire("Success", "JSON details uploaded successfully!", "success");
//     } catch (error) {
//       console.error("File upload failed:", error);
//       setUploadError(error.message);
//       Swal.fire("Error", `File upload failed: ${error.message}`, "error");
//       setIsUploadEnabled(true);
//       setIsCreateEnterpriseEnabled(false);
//     } finally {
//       setIsUploading(false);
//       Swal.close();
//     }
//   };

//   const handleTokenChange = (event) => setEnterpriseToken(event.target.value);

//   const handleCopyClick = () => {
//     if (signupUrl) {
//       navigator.clipboard.writeText(signupUrl);
//       Swal.fire("Success", "Signup URL copied to clipboard!", "success");
//     } else {
//       Swal.fire("Info", "No Signup URL to copy.", "info");
//     }
//   };

//   const handleCreateEnterprise = async () => {
//     if (!selectedFile) return Swal.fire("Warning", "Please upload a JSON file first.", "warning");
//     if (!signupUrlName) return Swal.fire("Warning", "Signup URL Name is required.", "warning");
//     if (!enterpriseToken) return Swal.fire("Warning", "Enterprise Token is required.", "warning");

//     setIsCreatingEnterprise(true);
//     setCreateEnterpriseError(null);
//     setIsCreateEnterpriseEnabled(false);

//     Swal.fire({
//       title: "Creating Enterprise...",
//       html:
//         '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div><div class="mt-2">Please wait while the enterprise is being created.</div>',
//       showConfirmButton: false,
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//     });

//     const formData = new FormData();
//     formData.append("jsonFile", selectedFile);
//     formData.append("signupUrlName", signupUrlName);
//     formData.append("enterpriseToken", enterpriseToken);

//     try {
//       const response = await fetch("https://spillas.com:3055/createEnterprise", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `HTTP error! status: ${response.status}, message: ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();

//       if (responseData?.enterprise?.name) {
//         const extractedId = responseData.enterprise.name.split("/").pop();
//         setEnterpriseId(extractedId);
//       }

//       Swal.fire("Success", "Enterprise Created successfully!", "success").then(() => {
//         setIsCreatePoliciesEnabled(true);
//       });
//     } catch (error) {
//       console.error("Create Enterprise API failed:", error);
//       setCreateEnterpriseError(error.message);
//       Swal.fire("Error", `Failed to create enterprise: ${error.message}`, "error");
//       setIsCreateEnterpriseEnabled(true);
//       setIsCreatePoliciesEnabled(false);
//     } finally {
//       setIsCreatingEnterprise(false);
//       Swal.close();
//     }
//   };

//   // ---------------- Policies (STEP 3) ----------------
//   const [policyCreationStatus, setPolicyCreationStatus] = useState({});
//   const policies = [
//     "goexzerotouch",
//     "UnlockDevice",
//     "LockDevice",
//     "UnistallDevice",
//     "DisableApp",
//     "unlockusb",
//     "developer_option_on",
//     "dev_usb_both_enable",
//     "hardlock",
//     "enableTethering",
//   ];

//   const createPolicy = async (policyName) => {
//     if (!selectedFile || !enterpriseId) {
//       console.warn("Selected file or Enterprise ID is missing for policy creation.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("enterpriseId", enterpriseId);
//     formData.append("policyName", policyName);
//     formData.append("jsonFile", selectedFile);
//     formData.append("orgId", 5865)

//     try {
//       const response = await fetch("https://spillas.com:3055/createPolicy", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `Failed to create policy ${policyName}: ${response.status} - ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();
//       if (responseData?.policy?.name?.includes(policyName)) {
//         setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: true }));
//       } else {
//         setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: false }));
//         console.warn(`Policy name in response does not match "${policyName}"`);
//       }
//     } catch (error) {
//       console.error(`Error creating policy "${policyName}":`, error);
//       setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: false }));
//       Swal.fire("Error", `Failed to create policy "${policyName}": ${error.message}`, "error");
//     }
//   };

//   const handleNextTab = () => {
//     toggleVerticalTab(activeVerticalTab + 1);
//     policies.forEach((p) => createPolicy(p));
//   };

//   // ---------------- Create Enrollment Token (STEP 4) ----------------
//   const [qrCodeUrl, setQrCodeUrl] = useState("");
//   const [enrollmentToken, setEnrollmentToken] = useState("");

//   const handleNextTabFromPolicy = async () => {
//     if (!selectedFile || !enterpriseId) {
//       Swal.fire("Warning", "Please ensure a file is uploaded and the enterprise is created.", "warning");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("enterpriseId", enterpriseId);
//     formData.append("jsonFile", selectedFile);

//     try {
//       const response = await fetch("https://spillas.com:3055/createEnrollmentToken", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `Failed to create enrollment token: ${response.status} - ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();
//       setQrCodeUrl(responseData.qrCodeUrl);
//       setEnrollmentToken(responseData.enrollmentToken);
//       Swal.fire("Success", "Enrollment Token created successfully!", "success");
//       toggleVerticalTab(activeVerticalTab + 1);
//     } catch (error) {
//       console.error("Error creating enrollment token:", error);
//       Swal.fire("Error", `Failed to create enrollment token: ${error.message}`, "error");
//     }
//   };

//   // ---------------- Assign Enterprise (STEP 5) ----------------
//   const [assignEnterpriseResponse, setAssignEnterpriseResponse] = useState("");

//   const assignEnterprise = async (setDefault) => {
//     if (!enterpriseId || !selectedUserDetails || !selectedRole) {
//       Swal.fire("Warning", "Please ensure enterprise, user, and role are selected.", "warning");
//       return;
//     }

//     const payload = {
//       enterprise_name: enterpriseId,
//       retailer_code: selectedUserDetails.org_code || "",
//       retailer_id: selectedUserDetails.id || "",
//       json_path: `public/storage/public/json/${enterpriseId}.json`,
//       default_enterprise: setDefault ? 1 : 0,
//       qr_url: `public/storage/public/qr/${enterpriseId}.png`,
//       entprise_type: 5,
//       company_id: selectedUserDetails.company_id || "",
//       company_name: selectedUserDetails.company_name || selectedUserDetails.business_name || "",
//       zresellerid: "ZR01",
//       zconfigid: "ZC01",
//       zcompanyid: "ZCOMP01",
//       role: 5,
//       email,
//       mobile,
//       password,
//     };

//     try {
//       const response = await fetch("https://spillas.com:3055/add-enterprise-to-db", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(`Failed: ${response.status} - ${errorData?.message || "Something went wrong"}`);
//       }

//       const responseData = await response.json();
//       setAssignEnterpriseResponse(responseData.message || "Enterprise added successfully!");
//       Swal.fire("Success", responseData.message || "Enterprise added successfully!", "success");
//       toggleVerticalTab(activeVerticalTab + 1);
//     } catch (error) {
//       console.error("Error assigning enterprise:", error);
//       Swal.fire("Error", `Failed to assign enterprise: ${error.message}`, "error");
//     }
//   };

//   const handleAssignEnterpriseConfirmation = (setDefault) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You are about to assign this enterprise.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, assign it!",
//     }).then((result) => {
//       if (result.isConfirmed) assignEnterprise(setDefault);
//     });
//   };

//   const handleSetProvisioningConfirmation = () => {
//   Swal.fire({
//     title: "Are you sure?",
//     text: "You are about to set this enterprise as provisioning.",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: "#3085d6",
//     cancelButtonColor: "#d33",
//     confirmButtonText: "Yes, set provisioning!",
//   }).then((result) => {
//     if (result.isConfirmed) assignEnterpriseProvisioning();
//   });
// };

// const assignEnterpriseProvisioning = async () => {
//   if (!enterpriseId || !selectedUserDetails || !selectedRole) {
//     Swal.fire("Warning", "Please ensure enterprise, user, and role are selected.", "warning");
//     return;
//   }

//   const payload = {
//     enterprise_name: enterpriseId,
//     retailer_code: selectedUserDetails.org_code || "",
//     retailer_id: selectedUserDetails.id || "",
//     json_path: `public/storage/public/json/${enterpriseId}.json`,
//     default_enterprise: 2, // <-- provisioning
//     qr_url: `public/storage/public/qr/${enterpriseId}.png`,
//     entprise_type: 5,
//     company_id: selectedUserDetails.company_id || "",
//     company_name: selectedUserDetails.company_name || selectedUserDetails.business_name || "",
//     zresellerid: "ZR01",
//     zconfigid: "ZC01",
//     zcompanyid: "ZCOMP01",
//     role: 5,
//     email,
//     mobile,
//     password,
//   };

//   try {
//     const response = await fetch("https://spillas.com:3055/add-enterprise-to-db", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(`Failed: ${response.status} - ${errorData?.message || "Something went wrong"}`);
//     }

//     const responseData = await response.json();
//     setAssignEnterpriseResponse(responseData.message || "Enterprise set as provisioning!");
//     Swal.fire("Success", responseData.message || "Enterprise set as provisioning!", "success");
//     toggleVerticalTab(activeVerticalTab + 1);
//   } catch (error) {
//     console.error("Error setting provisioning:", error);
//     Swal.fire("Error", `Failed to set provisioning: ${error.message}`, "error");
//   }
// };


//   // ---------------- UI ----------------
//   document.title = "Wizard | R.R. Technology";

//   // const step = (n, label) => (
//   //   <button
//   //     type="button"
//   //     onClick={() => toggleVerticalTab(n)}
//   //     className={classnames(
//   //       "w-full text-left rounded-xl px-3 py-2 transition border",
//   //       activeVerticalTab === n
//   //         ? "bg-blue-600 text-white border-blue-600"
//   //         : "bg-white text-zinc-700 hover:bg-zinc-50 border-zinc-200"
//   //     )}
//   //   >
//   //     <span className="text-xs opacity-80 mr-2">Step {n - 6}</span>
//   //     <span className="font-medium">{label}</span>
//   //   </button>
//   // );

//   const InputTW = (props) => (
//     <input
//       {...props}
//       className={
//         "w-full rounded-xl border border-zinc-200 px-3 py-2 text-sm outline-none placeholder:text-zinc-400 focus:border-blue-300 focus:ring-2 focus:ring-blue-200 " +
//         (props.className || "")
//       }
//     />
//   );

//   const LabelTW = ({ children, htmlFor }) => (
//     <label htmlFor={htmlFor} className="block text-sm font-medium text-zinc-700 mb-1">
//       {children}
//     </label>
//   );

//   const SectionCard = ({ title, children }) => (
//     <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
//       {title ? (
//         <div className="border-b border-zinc-200 bg-blue-50/60 px-4 py-3">
//           <h3 className="text-sm font-semibold text-blue-800">{title}</h3>
//         </div>
//       ) : null}
//       <div className="p-4">{children}</div>
//     </section>
//   );

//   const ButtonTW = ({ children, variant = "primary", type = "button", ...rest }) => {
//     const map = {
//         primary: "bg-blue-600 hover:bg-blue-500 text-white",
//         success: "bg-emerald-600 hover:bg-emerald-500 text-white",
//         danger: "bg-rose-600 hover:bg-rose-500 text-white",
//         secondary: "bg-zinc-100 hover:bg-zinc-200 text-zinc-800",
//     };

//     return (
//         <button
//         type={type}   // <-- default is "button", but you can pass "submit"
//         {...rest}
//         className={
//             "rounded-xl px-4 py-2 text-sm font-medium transition focus:outline-none focus:ring-2 " +
//             (variant === "primary"
//             ? "focus:ring-blue-200"
//             : variant === "success"
//             ? "focus:ring-emerald-200"
//             : variant === "danger"
//             ? "focus:ring-rose-200"
//             : "focus:ring-zinc-200") +
//             " " +
//             map[variant]
//         }
//         >
//         {children}
//         </button>
//     );
//     };

//     // helper function
// const step = (tabNumber, label) => {
//   const isActive = activeVerticalTab === tabNumber;
//   const isDone = activeVerticalTab <= 12 && activeVerticalTab >= tabNumber;

//   return (
//     <div
//       key={tabNumber}
//       className={`flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer
//         ${isActive ? "bg-blue-600 text-white" : ""}
//         ${!isActive && isDone ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}
//       `}
//       onClick={() => setActiveVerticalTab(tabNumber)}
//     >
//       <i
//         className={`ri-close-circle-fill step-icon
//           ${isActive ? "text-white" : isDone ? "text-green-600" : "text-gray-400"}
//         `}
//       ></i>
//       <span className="font-medium">Step {tabNumber - 6}</span>
//       <span>{label}</span>
//     </div>
//   );
// };



//   return (
//     <div className="min-h-screen bg-white text-zinc-900"> 
//       {/* Header / Breadcrumb */}
//       <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
//         <div className="mx-auto max-w-7xl px-4 py-4">
//           {/* <BreadCrumb title="Forms" breadcrumbItem="Wizard" /> */}
//           <h1 className="mt-1 text-xl font-semibold tracking-tight">CREATE ENTERPRISE</h1>
//         </div>
//       </header>

//       <main className="mx-auto max-w-7xl px-4 py-6">
        
//         <SectionCard>
//           <div className="pt-3 pb-3">
//           <button
//             className="bg-blue-500 hover:bg-blue-400 cursor-pointer text-white px-2 py-1 rounded-md flex items-center gap-1"
//             onClick={() => navigate(-1)}
//           >
//             <FaArrowLeft /> Go Back
//           </button>
//         </div>
//           <form className="w-full">
//             <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//               {/* Left: Steps */}
//               <div className="col-span-12 md:col-span-4 lg:col-span-3">
//                 <div className="flex flex-col gap-2">
//                   {step(7, "Select User")}
//                   {step(8, "Upload Json")}
//                   {step(9, "Create Policies")}
//                   {step(10, "Create QR")}
//                   {step(11, "Set as Default")}
//                 </div>
//               </div>

//               {/* Right: Content */}
//                  <div className="col-span-12 md:col-span-8 lg:col-span-9">
//                   {/* STEP 1 */}
//                   <div
//                     style={{ display: activeVerticalTab === 7 ? "block" : "none" }}>
//                   <SectionCard title="Step 1 — Select User">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                       {/* Role Selection */}
//                       <div>
//                         <LabelTW htmlFor="keyType">Select Role</LabelTW>
//                         <select
//                           id="keyType"
//                           value={selectedRole}
//                           onChange={handleRoleChange}
//                           className="w-full rounded-xl border border-zinc-200 bg-white px-3 py-2 text-sm outline-none focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
//                         >
//                           <option value="">Select Role</option>
//                           {roles.map((role) => (
//                             <option key={role.id} value={role.id}>
//                               {role.name}
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                       {/* User Selection */}
//                       <div>
//                         <LabelTW htmlFor="user">Select User</LabelTW>
//                         <Select
//                           id="user"
//                           options={users}
//                           value={selectedUser}
//                           onChange={handleUserChange}
//                           isDisabled={!selectedRole}
//                           placeholder="Search for a User"
//                           isSearchable
//                           styles={{
//                             control: (base, state) => ({
//                               ...base,
//                               minHeight: "40px",
//                               borderColor: state.isFocused ? "#86b7fe" : "#e4e4e7",
//                               boxShadow: state.isFocused
//                                 ? "0 0 0 0.2rem rgba(37,99,235,.15)"
//                                 : "none",
//                             }),
//                           }}
//                         />
//                       </div>
//                     </div>

//                     {/* Selected User Details */}
//                     {selectedUserDetails && (
//                       <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm">
//                         <div>
//                           <div className="text-zinc-500">Code</div>
//                           <div className="font-medium">
//                             {selectedUserDetails.org_code}
//                           </div>
//                         </div>
//                         <div>
//                           <div className="text-zinc-500">Name</div>
//                           <div className="font-medium">
//                             {selectedUserDetails.business_name}
//                           </div>
//                         </div>
//                         <div>
//                           <div className="text-zinc-500">Email</div>
//                           <div className="font-medium">{selectedUserDetails.email}</div>
//                         </div>
//                         <div>
//                           <div className="text-zinc-500">Phone</div>
//                           <div className="font-medium">{selectedUserDetails.mobile}</div>
//                         </div>
//                       </div>
//                     )}

//                     {/* Inputs */}
//                     <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <div>
//                         <LabelTW htmlFor="email">Email</LabelTW>
//                         <InputTW
//                           id="email"
//                           type="email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           placeholder="Enter email"
//                         />
//                       </div>
//                       <div>
//                         <LabelTW htmlFor="password">Password</LabelTW>
//                         <InputTW
//                           id="password"
//                           type="password"
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                           placeholder="Enter password"
//                         />
//                       </div>
//                       <div>
//                         <LabelTW htmlFor="mobile">Mobile Number</LabelTW>
//                         <InputTW
//                           id="mobile"
//                           type="tel"
//                           value={mobile}
//                           onChange={(e) => setMobile(e.target.value)}
//                           placeholder="Enter mobile number"
//                         />
//                       </div>
//                     </div>

//                     <div className="mt-5 flex justify-end">
//                       <ButtonTW
//                         variant="success"
//                         onClick={() => toggleVerticalTab(activeVerticalTab + 1)}
//                         disabled={
//                           !selectedRole ||
//                           !selectedUser ||
//                           !email ||
//                           !password ||
//                           !mobile
//                         }
//                       >
//                         Next
//                       </ButtonTW>
//                     </div>
//                   </SectionCard>
//                 </div>

//                 {/* STEP 2 */}
//                 <div style={{ display: activeVerticalTab === 8 ? "block" : "none" }} >
//                   <SectionCard title="Step 2 — Upload Json & Create Enterprise">
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
//                       <div className="md:col-span-2">
//                         <LabelTW>Upload JSON</LabelTW>
//                         <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
//                           <input
//                             ref={fileInputRef}
//                             type="file"
//                             accept=".json"
//                             onChange={handleFileChange}
//                             className="hidden"
//                             id="jsonUpload"
//                           />
//                           <label
//                             htmlFor="jsonUpload"
//                             className="flex-1 cursor-pointer rounded-xl border border-zinc-200 px-3 py-2 text-sm text-zinc-600 bg-white w-full"
//                           >
//                             {selectedFile ? selectedFile.name : "Choose file..."}
//                           </label>
//                           <button
//                             type="button"
//                             onClick={handleUploadClick}
//                             disabled={!selectedFile}
//                             className="rounded-xl bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-500 disabled:bg-zinc-400"
//                           >
//                             Upload JSON
//                           </button>
//                         </div>
//                         {uploadError && (
//                           <p className="text-rose-600 text-sm mt-2">{uploadError}</p>
//                         )}
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end mt-4">
//                       <div className="md:col-span-2">
//                         <LabelTW>Signup URL</LabelTW>
//                         <InputTW
//                           value={signupUrl}
//                           readOnly
//                           placeholder="Signup URL will appear here..."
//                         />
//                       </div>
//                       <div className="flex">
//                         <ButtonTW
//                           variant="success"
//                           onClick={handleCopyClick}
//                           disabled={!signupUrl}
//                         >
//                           Copy
//                         </ButtonTW>
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
//                       <div className="md:col-span-2">
//                         <LabelTW>Signup URL Name</LabelTW>
//                         <InputTW
//                           value={signupUrlName}
//                           readOnly
//                           placeholder="Signup URL Name will appear here..."
//                         />
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end mt-4">
//                       <div className="md:col-span-2">
//                         <LabelTW>Enterprise Token</LabelTW>
//                         <InputTW
//                           placeholder="Paste Token Here..."
//                           value={enterpriseToken}
//                           onChange={handleTokenChange}
//                         />
//                       </div>
//                       <div className="flex">
//                         <ButtonTW
//                           variant="success"
//                           onClick={handleCreateEnterprise}
//                           disabled={
//                             isCreatingEnterprise ||
//                             !signupUrlName ||
//                             !enterpriseToken ||
//                             !selectedFile ||
//                             !isCreateEnterpriseEnabled
//                           }
//                         >
//                           Create Enterprise
//                         </ButtonTW>
//                       </div>
//                     </div>

//                     <div className="mt-5 flex justify-end">
//                       <ButtonTW
//                         variant="success"
//                         onClick={handleNextTab}
//                         disabled={!isCreatePoliciesEnabled}
//                       >
//                         Next
//                       </ButtonTW>
//                     </div>

//                     {createEnterpriseError && (
//                       <div className="text-rose-600 text-sm mt-2">
//                         {createEnterpriseError}
//                       </div>
//                     )}
//                   </SectionCard>
//                 </div>

//                 {/* STEP 3 */}
//                 <div style={{ display: activeVerticalTab === 9 ? "block" : "none" }} >
//                   <SectionCard title="Step 3 — Create Policies">
//                     <ul className="space-y-2">
//                       {policies.map((policy) => (
//                         <li key={policy} className="flex items-center gap-2">
//                           {policyCreationStatus[policy] === true ? (
//                             <i className="ri-checkbox-circle-fill text-emerald-600 text-lg" />
//                           ) : policyCreationStatus[policy] === false ? (
//                             <i className="ri-close-circle-fill text-rose-600 text-lg" />
//                           ) : (
//                             <i className="ri-time-line text-amber-500 text-lg" />
//                           )}
//                           <span className="text-sm">{policy}</span>
//                         </li>
//                       ))}
//                     </ul>

//                     <div className="mt-5 flex justify-end">
//                       <ButtonTW
//                         variant="success"
//                         onClick={handleNextTabFromPolicy}
//                         disabled={!isCreatePoliciesEnabled}
//                       >
//                         Next
//                       </ButtonTW>
//                     </div>
//                   </SectionCard>
//                 </div>

//                 {/* STEP 4 */}
//                 <div style={{ display: activeVerticalTab === 10 ? "block" : "none" }}>
//                   <SectionCard title="Step 4 — Create QR">
//                     <div className="flex flex-col items-center justify-center py-4">
//                       {qrCodeUrl ? (
//                         <img
//                           src={qrCodeUrl}
//                           alt="QR Code"
//                           className="w-[200px] sm:w-[250px] h-auto object-contain rounded-xl border border-zinc-200"
//                         />
//                       ) : (
//                         <p className="text-sm text-zinc-500">
//                           QR Code will appear here after successful creation.
//                         </p>
//                       )}
//                     </div>

//                     <div className="flex flex-col sm:flex-row justify-end gap-2">
//                       <ButtonTW
//                         variant="success"
//                         onClick={() => handleAssignEnterpriseConfirmation(false)}
//                         disabled={!qrCodeUrl}
//                       >
//                         Save & Continue
//                       </ButtonTW>
//                       <ButtonTW
//                         variant="success"
//                         onClick={() => handleAssignEnterpriseConfirmation(true)}
//                         disabled={!qrCodeUrl}
//                       >
//                         Set as Default
//                       </ButtonTW>
//                       <ButtonTW
//                         variant="secondary"
//                         onClick={handleSetProvisioningConfirmation}
//                         disabled={!qrCodeUrl}
//                       >
//                         Set Provisioning
//                       </ButtonTW>
//                     </div>
//                   </SectionCard>
//                 </div>

//                 {/* STEP 5 */}
//                 <div style={{ display: activeVerticalTab === 11 ? "block" : "none" }} >
//                   <SectionCard title="Step 5 — Completed">
//                     <div className="text-center py-6">
//                       <div className="mb-4">
//                         <lord-icon
//                           src="https://cdn.lordicon.com/lupuorrc.json"
//                           trigger="loop"
//                           colors="primary:#0ab39c,secondary:#405189"
//                           style={{ width: "120px", height: "120px" }}
//                         ></lord-icon>
//                       </div>
//                       <h5 className="text-lg font-semibold">
//                         Your Enterprise is Completed!
//                       </h5>
//                       <p className="text-sm text-zinc-600 mt-1">
//                         {assignEnterpriseResponse}
//                       </p>
//                     </div>
//                   </SectionCard>
//                 </div>
//               </div>
//             </div>
//           </form>

//         </SectionCard>
//       </main>
//     </div>
//   );
// };

// export default FormWizardTesting;


// // src/pages/Enterprise/FormWizardTesting.jsx
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import Select from "react-select";
// import classnames from "classnames";
// // import BreadCrumb from "../../../Components/Common/BreadCrumb";
// import { loadAnimation } from "lottie-web";
// import { defineElement } from "lord-icon-element";
// import Swal from "sweetalert2";
// import { FaArrowLeft, FaCheck, FaTimes } from "react-icons/fa";
// import { Link, useNavigate } from "react-router-dom";

// defineElement(loadAnimation);

// const FormWizardTesting = () => {
//   const navigate = useNavigate();

//   // ---------------- Tabs ----------------
//   const [activeVerticalTab, setactiveVerticalTab] = useState(7);
//   const [passedverticalSteps, setPassedverticalSteps] = useState([1]);
//   function toggleVerticalTab(tab) {
//     if (activeVerticalTab !== tab) {
//       const modifiedSteps = [...passedverticalSteps, tab];
//       if (tab >= 7 && tab <= 12) {
//         setactiveVerticalTab(tab);
//         setPassedverticalSteps(modifiedSteps);
//       }
//     }
//   }

//   // ---------------- User / Role (STEP 1) ----------------
//   const [roles, setRoles] = useState([]);
//   const [selectedRole, setSelectedRole] = useState("");
//   const [users, setUsers] = useState([]);
//   const [allUsersData, setAllUsersData] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [selectedUserDetails, setSelectedUserDetails] = useState(null);

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobile, setMobile] = useState("");

//   const fetchRoles = useCallback(async () => {
//     try {
//       const response = await fetch("https://spillas.comapi/v1/org_user/roles");
//       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//       const data = await response.json();
//       // original filter kept: Retailers only
//       const filteredRoles = data.filter((role) => role.name === "Retailers");
//       setRoles(filteredRoles);
//     } catch (error) {
//       console.error("Could not fetch roles:", error);
//     }
//   }, []);

//   useEffect(() => {
//     fetchRoles();
//   }, [fetchRoles]);

//   const fetchUsersByRole = useCallback(
//     async (roleId) => {
//       if (roleId) {
//         let apiRoleId;
//         const foundRole = roles.find((role) => role.id === parseInt(roleId));
//         if (foundRole?.name?.toLowerCase() === "retailers") apiRoleId = 7;
//         else if (foundRole?.name?.toLowerCase() === "company") apiRoleId = 2;

//         if (apiRoleId) {
//           try {
//             const response = await fetch(
//               // original endpoint you used (kept)
//               `https://spillas.comapi/v1/org_user?role=5&per_page=10000000000`
//             );
//             const data = await response.json();
//             if (data && data.data) {
//               setAllUsersData(data.data);
//               const formattedUsers = data.data.map((user) => ({
//                 value: user.id,
//                 label: `${user.org_code} - ${user.business_name}`,
//               }));
//               setUsers(formattedUsers);
//             } else {
//               setUsers([]);
//               setAllUsersData([]);
//             }
//           } catch (error) {
//             console.error("Error fetching users:", error);
//             setUsers([]);
//             setAllUsersData([]);
//           }
//         } else {
//           setUsers([]);
//           setAllUsersData([]);
//         }
//       } else {
//         setUsers([]);
//         setAllUsersData([]);
//       }
//     },
//     [roles]
//   );

//   const handleRoleChange = (e) => {
//     const roleId = e.target.value;
//     setSelectedRole(roleId);
//     setSelectedUser(null);
//     setSelectedUserDetails(null);
//     fetchUsersByRole(roleId);
//   };

//   const handleUserChange = (selectedOption) => {
//     setSelectedUser(selectedOption);
//     if (selectedOption) {
//       const foundUser = allUsersData.find((user) => user.id === selectedOption.value);
//       setSelectedUserDetails(foundUser);
//     } else {
//       setSelectedUserDetails(null);
//     }
//   };

//   // ---------------- JSON Upload / Create Enterprise (STEP 2) ----------------
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [signupUrl, setSignupUrl] = useState("");
//   const [signupUrlName, setSignupUrlName] = useState("");
//   const [enterpriseToken, setEnterpriseToken] = useState("");
//   const [isUploading, setIsUploading] = useState(false);
//   const [isCreatingEnterprise, setIsCreatingEnterprise] = useState(false);
//   const [uploadError, setUploadError] = useState(null);
//   const [createEnterpriseError, setCreateEnterpriseError] = useState(null);
//   const [isUploadEnabled, setIsUploadEnabled] = useState(false);
//   const [isCreateEnterpriseEnabled, setIsCreateEnterpriseEnabled] = useState(false);
//   const [isCreatePoliciesEnabled, setIsCreatePoliciesEnabled] = useState(false);
//   const fileInputRef = useRef(null);
//   const [enterpriseId, setEnterpriseId] = useState("");

//   const handleFileChange = (event) => {
//     setSelectedFile(event.target.files[0]);
//     setIsUploadEnabled(event.target.files[0] !== null);
//   };

//   const handleUploadClick = async () => {
//     if (!selectedFile) {
//       Swal.fire("Error", "Please select a JSON file first.", "error");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("jsonFile", selectedFile);

//     setIsUploading(true);
//     setUploadError(null);
//     setIsUploadEnabled(false);

//     Swal.fire({
//       title: "Uploading JSON details...",
//       html:
//         '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div><div class="mt-2">Please wait while the JSON data is being uploaded.</div>',
//       showConfirmButton: false,
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//     });

//     try {
//       const response = await fetch("https://spillas.com:3055/signup", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `HTTP error! status: ${response.status}, message: ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();
//       setSignupUrl(responseData.signupUrl);
//       setSignupUrlName(responseData.signupUrlName);
//       setIsCreateEnterpriseEnabled(true);
//       Swal.fire("Success", "JSON details uploaded successfully!", "success");
//     } catch (error) {
//       console.error("File upload failed:", error);
//       setUploadError(error.message);
//       Swal.fire("Error", `File upload failed: ${error.message}`, "error");
//       setIsUploadEnabled(true);
//       setIsCreateEnterpriseEnabled(false);
//     } finally {
//       setIsUploading(false);
//       Swal.close();
//     }
//   };

//   const handleTokenChange = (event) => setEnterpriseToken(event.target.value);

//   const handleCopyClick = () => {
//     if (signupUrl) {
//       navigator.clipboard.writeText(signupUrl);
//       Swal.fire("Success", "Signup URL copied to clipboard!", "success");
//     } else {
//       Swal.fire("Info", "No Signup URL to copy.", "info");
//     }
//   };

//   const handleCreateEnterprise = async () => {
//     if (!selectedFile) return Swal.fire("Warning", "Please upload a JSON file first.", "warning");
//     if (!signupUrlName) return Swal.fire("Warning", "Signup URL Name is required.", "warning");
//     if (!enterpriseToken) return Swal.fire("Warning", "Enterprise Token is required.", "warning");

//     setIsCreatingEnterprise(true);
//     setCreateEnterpriseError(null);
//     setIsCreateEnterpriseEnabled(false);

//     Swal.fire({
//       title: "Creating Enterprise...",
//       html:
//         '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div><div class="mt-2">Please wait while the enterprise is being created.</div>',
//       showConfirmButton: false,
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//     });

//     const formData = new FormData();
//     formData.append("jsonFile", selectedFile);
//     formData.append("signupUrlName", signupUrlName);
//     formData.append("enterpriseToken", enterpriseToken);

//     try {
//       const response = await fetch("https://spillas.com:3055/createEnterprise", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `HTTP error! status: ${response.status}, message: ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();

//       if (responseData?.enterprise?.name) {
//         const extractedId = responseData.enterprise.name.split("/").pop();
//         setEnterpriseId(extractedId);
//       }

//       Swal.fire("Success", "Enterprise Created successfully!", "success").then(() => {
//         setIsCreatePoliciesEnabled(true);
//       });
//     } catch (error) {
//       console.error("Create Enterprise API failed:", error);
//       setCreateEnterpriseError(error.message);
//       Swal.fire("Error", `Failed to create enterprise: ${error.message}`, "error");
//       setIsCreateEnterpriseEnabled(true);
//       setIsCreatePoliciesEnabled(false);
//     } finally {
//       setIsCreatingEnterprise(false);
//       Swal.close();
//     }
//   };

//   // ---------------- Policies (STEP 3) ----------------
//   const [policyCreationStatus, setPolicyCreationStatus] = useState({});
//   const policies = [
//     "goexzerotouch",
//     "UnlockDevice",
//     "LockDevice",
//     "UnistallDevice",
//     "DisableApp",
//     "unlockusb",
//     "developer_option_on",
//     "dev_usb_both_enable",
//     "hardlock",
//     "enableTethering",
//   ];

//   const createPolicy = async (policyName) => {
//     if (!selectedFile || !enterpriseId) {
//       console.warn("Selected file or Enterprise ID is missing for policy creation.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("enterpriseId", enterpriseId);
//     formData.append("policyName", policyName);
//     formData.append("jsonFile", selectedFile);
//     formData.append("orgId", 5865)

//     try {
//       const response = await fetch("https://spillas.com:3055/createPolicy", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `Failed to create policy ${policyName}: ${response.status} - ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();
//       if (responseData?.policy?.name?.includes(policyName)) {
//         setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: true }));
//       } else {
//         setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: false }));
//         console.warn(`Policy name in response does not match "${policyName}"`);
//       }
//     } catch (error) {
//       console.error(`Error creating policy "${policyName}":`, error);
//       setPolicyCreationStatus((prev) => ({ ...prev, [policyName]: false }));
//       Swal.fire("Error", `Failed to create policy "${policyName}": ${error.message}`, "error");
//     }
//   };

//   const handleNextTab = () => {
//     toggleVerticalTab(activeVerticalTab + 1);
//     policies.forEach((p) => createPolicy(p));
//   };

//   // ---------------- Create Enrollment Token (STEP 4) ----------------
//   const [qrCodeUrl, setQrCodeUrl] = useState("");
//   const [enrollmentToken, setEnrollmentToken] = useState("");

//   const handleNextTabFromPolicy = async () => {
//     if (!selectedFile || !enterpriseId) {
//       Swal.fire("Warning", "Please ensure a file is uploaded and the enterprise is created.", "warning");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("enterpriseId", enterpriseId);
//     formData.append("jsonFile", selectedFile);

//     try {
//       const response = await fetch("https://spillas.com:3055/createEnrollmentToken", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           `Failed to create enrollment token: ${response.status} - ${errorData?.message || "Something went wrong"}`
//         );
//       }

//       const responseData = await response.json();
//       setQrCodeUrl(responseData.qrCodeUrl);
//       setEnrollmentToken(responseData.enrollmentToken);
//       Swal.fire("Success", "Enrollment Token created successfully!", "success");
//       toggleVerticalTab(activeVerticalTab + 1);
//     } catch (error) {
//       console.error("Error creating enrollment token:", error);
//       Swal.fire("Error", `Failed to create enrollment token: ${error.message}`, "error");
//     }
//   };

//   // ---------------- Assign Enterprise (STEP 5) ----------------
//   const [assignEnterpriseResponse, setAssignEnterpriseResponse] = useState("");

//   const assignEnterprise = async (setDefault) => {
//     if (!enterpriseId || !selectedUserDetails || !selectedRole) {
//       Swal.fire("Warning", "Please ensure enterprise, user, and role are selected.", "warning");
//       return;
//     }

//     const payload = {
//       enterprise_name: enterpriseId,
//       retailer_code: selectedUserDetails.org_code || "",
//       retailer_id: selectedUserDetails.id || "",
//       json_path: `public/storage/public/json/${enterpriseId}.json`,
//       default_enterprise: setDefault ? 1 : 0,
//       qr_url: `public/storage/public/qr/${enterpriseId}.png`,
//       entprise_type: 5,
//       company_id: selectedUserDetails.company_id || "",
//       company_name: selectedUserDetails.company_name || selectedUserDetails.business_name || "",
//       zresellerid: "ZR01",
//       zconfigid: "ZC01",
//       zcompanyid: "ZCOMP01",
//       role: 5,
//       email,
//       mobile,
//       password,
//     };

//     try {
//       const response = await fetch("https://spillas.com:3055/add-enterprise-to-db", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(`Failed: ${response.status} - ${errorData?.message || "Something went wrong"}`);
//       }

//       const responseData = await response.json();
//       setAssignEnterpriseResponse(responseData.message || "Enterprise added successfully!");
//       Swal.fire("Success", responseData.message || "Enterprise added successfully!", "success");
//       toggleVerticalTab(activeVerticalTab + 1);
//     } catch (error) {
//       console.error("Error assigning enterprise:", error);
//       Swal.fire("Error", `Failed to assign enterprise: ${error.message}`, "error");
//     }
//   };

//   const handleAssignEnterpriseConfirmation = (setDefault) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You are about to assign this enterprise.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, assign it!",
//     }).then((result) => {
//       if (result.isConfirmed) assignEnterprise(setDefault);
//     });
//   };

//   const handleSetProvisioningConfirmation = () => {
//   Swal.fire({
//     title: "Are you sure?",
//     text: "You are about to set this enterprise as provisioning.",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: "#3085d6",
//     cancelButtonColor: "#d33",
//     confirmButtonText: "Yes, set provisioning!",
//   }).then((result) => {
//     if (result.isConfirmed) assignEnterpriseProvisioning();
//   });
// };

// const assignEnterpriseProvisioning = async () => {
//   if (!enterpriseId || !selectedUserDetails || !selectedRole) {
//     Swal.fire("Warning", "Please ensure enterprise, user, and role are selected.", "warning");
//     return;
//   }

//   const payload = {
//     enterprise_name: enterpriseId,
//     retailer_code: selectedUserDetails.org_code || "",
//     retailer_id: selectedUserDetails.id || "",
//     json_path: `public/storage/public/json/${enterpriseId}.json`,
//     default_enterprise: 2, // <-- provisioning
//     qr_url: `public/storage/public/qr/${enterpriseId}.png`,
//     entprise_type: 5,
//     company_id: selectedUserDetails.company_id || "",
//     company_name: selectedUserDetails.company_name || selectedUserDetails.business_name || "",
//     zresellerid: "ZR01",
//     zconfigid: "ZC01",
//     zcompanyid: "ZCOMP01",
//     role: 5,
//     email,
//     mobile,
//     password,
//   };

//   try {
//     const response = await fetch("https://spillas.com:3055/add-enterprise-to-db", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(`Failed: ${response.status} - ${errorData?.message || "Something went wrong"}`);
//     }

//     const responseData = await response.json();
//     setAssignEnterpriseResponse(responseData.message || "Enterprise set as provisioning!");
//     Swal.fire("Success", responseData.message || "Enterprise set as provisioning!", "success");
//     toggleVerticalTab(activeVerticalTab + 1);
//   } catch (error) {
//     console.error("Error setting provisioning:", error);
//     Swal.fire("Error", `Failed to set provisioning: ${error.message}`, "error");
//   }
// };


//   // ---------------- UI ----------------
//   document.title = "Wizard | R.R. Technology";

//   // const step = (n, label) => (
//   //   <button
//   //     type="button"
//   //     onClick={() => toggleVerticalTab(n)}
//   //     className={classnames(
//   //       "w-full text-left rounded-xl px-3 py-2 transition border",
//   //       activeVerticalTab === n
//   //         ? "bg-blue-600 text-white border-blue-600"
//   //         : "bg-white text-zinc-700 hover:bg-zinc-50 border-zinc-200"
//   //     )}
//   //   >
//   //     <span className="text-xs opacity-80 mr-2">Step {n - 6}</span>
//   //     <span className="font-medium">{label}</span>
//   //   </button>
//   // );

//   const InputTW = (props) => (
//     <input
//       {...props}
//       className={
//         "w-full rounded-xl border border-zinc-200 px-3 py-2 text-sm outline-none placeholder:text-zinc-400 focus:border-blue-300 focus:ring-2 focus:ring-blue-200 " +
//         (props.className || "")
//       }
//     />
//   );

//   const LabelTW = ({ children, htmlFor }) => (
//     <label htmlFor={htmlFor} className="block text-sm font-medium text-zinc-700 mb-1">
//       {children}
//     </label>
//   );

//   const SectionCard = ({ title, children }) => (
//     <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
//       {title ? (
//         <div className="border-b border-zinc-200 bg-blue-50/60 px-4 py-3">
//           <h3 className="text-sm font-semibold text-blue-800">{title}</h3>
//         </div>
//       ) : null}
//       <div className="p-4">{children}</div>
//     </section>
//   );

//   const ButtonTW = ({ children, variant = "primary", type = "button", ...rest }) => {
//     const map = {
//         primary: "bg-blue-600 hover:bg-blue-500 text-white",
//         success: "bg-emerald-600 hover:bg-emerald-500 text-white",
//         danger: "bg-rose-600 hover:bg-rose-500 text-white",
//         secondary: "bg-zinc-100 hover:bg-zinc-200 text-zinc-800",
//     };

//     return (
//         <button
//         type={type}   // <-- default is "button", but you can pass "submit"
//         {...rest}
//         className={
//             "rounded-xl px-4 py-2 text-sm font-medium transition focus:outline-none focus:ring-2 " +
//             (variant === "primary"
//             ? "focus:ring-blue-200"
//             : variant === "success"
//             ? "focus:ring-emerald-200"
//             : variant === "danger"
//             ? "focus:ring-rose-200"
//             : "focus:ring-zinc-200") +
//             " " +
//             map[variant]
//         }
//         >
//         {children}
//         </button>
//     );
//     };

//     // helper function
// const step = (tabNumber, label) => {
//   const isActive = activeVerticalTab === tabNumber;
//   const isDone = activeVerticalTab <= 12 && activeVerticalTab >= tabNumber;

//   return (
//     <div
//       key={tabNumber}
//       className={`flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer
//         ${isActive ? "bg-blue-600 text-white" : ""}
//         ${!isActive && isDone ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}
//       `}
//       onClick={() => setActiveVerticalTab(tabNumber)}
//     >
//       <i
//         className={`ri-close-circle-fill step-icon
//           ${isActive ? "text-white" : isDone ? "text-green-600" : "text-gray-400"}
//         `}
//       ></i>
//       <span className="font-medium">Step {tabNumber - 6}</span>
//       <span>{label}</span>
//     </div>
//   );
// };



//   return (
//     <div className="min-h-screen bg-white text-zinc-900"> 
//       {/* Header / Breadcrumb */}
//       <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
//         <div className="mx-auto max-w-7xl px-4 py-4">
//           {/* <BreadCrumb title="Forms" breadcrumbItem="Wizard" /> */}
//           <h1 className="mt-1 text-xl font-semibold tracking-tight">CREATE ENTERPRISE</h1>
//         </div>
//       </header>

//       <main className="mx-auto max-w-7xl px-4 py-6">
        
//         <SectionCard>
//           <div className="pt-3 pb-3">
//           <button
//             className="bg-blue-500 hover:bg-blue-400 cursor-pointer text-white px-2 py-1 rounded-md flex items-center gap-1"
//             onClick={() => navigate(-1)}
//           >
//             <FaArrowLeft /> Go Back
//           </button>
//         </div>
//           <form className="w-full">
//            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//               {/* Left: Steps */}
//               <div className="col-span-12 md:col-span-4 lg:col-span-3 ">
//                 <div className="flex flex-col gap-2">
//                   {step(7, "Select User")}
//                   {step(8, "Upload Json")}
//                   {step(9, "Create Policies")}
//                   {step(10, "Create QR")}
//                   {step(11, "Set as Default")}
//                 </div>
//               </div>

//               {/* Right: Content */}
//               <div className="col-span-12 md:col-span-8 lg:col-span-9">
//                 {/* STEP 1 */}
//                 <div hidden={activeVerticalTab !== 7}>
//                   <SectionCard title="Step 1 — Select User">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                       {/* Role Selection */}
//                       <div>
//                         <LabelTW htmlFor="keyType">Select Role</LabelTW>
//                         <select
//                           id="keyType"
//                           value={selectedRole}
//                           onChange={handleRoleChange}
//                           className="w-full rounded-xl border border-zinc-200 bg-white px-3 py-2 text-sm outline-none focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
//                         >
//                           <option value="">Select Role</option>
//                           {roles.map((role) => (
//                             <option key={role.id} value={role.id}>
//                               {role.name}
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                       {/* User Selection */}
//                       <div>
//                         <LabelTW htmlFor="user">Select User</LabelTW>
//                         <Select
//                           id="user"
//                           options={users}
//                           value={selectedUser}
//                           onChange={handleUserChange}
//                           isDisabled={!selectedRole}
//                           placeholder="Search for a User"
//                           isSearchable
//                           styles={{
//                             control: (base, state) => ({
//                               ...base,
//                               minHeight: "40px",
//                               borderColor: state.isFocused ? "#86b7fe" : "#e4e4e7",
//                               boxShadow: state.isFocused
//                                 ? "0 0 0 0.2rem rgba(37,99,235,.15)"
//                                 : "none",
//                             }),
//                           }}
//                         />
//                       </div>
//                     </div>

//                     {/* Selected User Details */}
//                     {selectedUserDetails && (
//                       <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm">
//                         <div>
//                           <div className="text-zinc-500">Code</div>
//                           <div className="font-medium">
//                             {selectedUserDetails.org_code}
//                           </div>
//                         </div>
//                         <div>
//                           <div className="text-zinc-500">Name</div>
//                           <div className="font-medium">
//                             {selectedUserDetails.business_name}
//                           </div>
//                         </div>
//                         <div>
//                           <div className="text-zinc-500">Email</div>
//                           <div className="font-medium">{selectedUserDetails.email}</div>
//                         </div>
//                         <div>
//                           <div className="text-zinc-500">Phone</div>
//                           <div className="font-medium">{selectedUserDetails.mobile}</div>
//                         </div>
//                       </div>
//                     )}

//                     {/* Inputs */}
//                     <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <div>
//                         <LabelTW htmlFor="email">Email</LabelTW>
//                         <InputTW
//                           id="email"
//                           type="email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           placeholder="Enter email"
//                         />
//                       </div>
//                       <div>
//                         <LabelTW htmlFor="password">Password</LabelTW>
//                         <InputTW
//                           id="password"
//                           type="password"
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                           placeholder="Enter password"
//                         />
//                       </div>
//                       <div>
//                         <LabelTW htmlFor="mobile">Mobile Number</LabelTW>
//                         <InputTW
//                           id="mobile"
//                           type="tel"
//                           value={mobile}
//                           onChange={(e) => setMobile(e.target.value)}
//                           placeholder="Enter mobile number"
//                         />
//                       </div>
//                     </div>

//                     <div className="mt-5 flex justify-end">
//                       <ButtonTW
//                         variant="success"
//                         onClick={() => toggleVerticalTab(activeVerticalTab + 1)}
//                         disabled={
//                           !selectedRole || !selectedUser || !email || !password || !mobile
//                         }
//                       >
//                         Next
//                       </ButtonTW>
//                     </div>
//                   </SectionCard>
//                 </div>

//                 {/* STEP 2 */}
//                 {activeVerticalTab === 8 && (
//                   <SectionCard title="Step 2 — Upload Json & Create Enterprise">
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
//                       <div className="md:col-span-2">
//                         <LabelTW>Upload JSON</LabelTW>
//                         <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
//                           <input
//                             ref={fileInputRef}
//                             type="file"
//                             accept=".json"
//                             onChange={handleFileChange}
//                             className="hidden"
//                             id="jsonUpload"
//                           />
//                           <label
//                             htmlFor="jsonUpload"
//                             className="flex-1 cursor-pointer rounded-xl border border-zinc-200 px-3 py-2 text-sm text-zinc-600 bg-white w-full"
//                           >
//                             {selectedFile ? selectedFile.name : "Choose file..."}
//                           </label>
//                           <button
//                             type="button"
//                             onClick={handleUploadClick}
//                             disabled={!selectedFile}
//                             className="rounded-xl bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-500 disabled:bg-zinc-400"
//                           >
//                             Upload JSON
//                           </button>
//                         </div>
//                         {uploadError && (
//                           <p className="text-rose-600 text-sm mt-2">{uploadError}</p>
//                         )}
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end mt-4">
//                       <div className="md:col-span-2">
//                         <LabelTW>Signup URL</LabelTW>
//                         <InputTW
//                           value={signupUrl}
//                           readOnly
//                           placeholder="Signup URL will appear here..."
//                         />
//                       </div>
//                       <div className="flex">
//                         <ButtonTW
//                           variant="success"
//                           onClick={handleCopyClick}
//                           disabled={!signupUrl}
//                         >
//                           Copy
//                         </ButtonTW>
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
//                       <div className="md:col-span-2">
//                         <LabelTW>Signup URL Name</LabelTW>
//                         <InputTW
//                           value={signupUrlName}
//                           readOnly
//                           placeholder="Signup URL Name will appear here..."
//                         />
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end mt-4">
//                       <div className="md:col-span-2">
//                         <LabelTW>Enterprise Token</LabelTW>
//                         <InputTW
//                           placeholder="Paste Token Here..."
//                           value={enterpriseToken}
//                           onChange={handleTokenChange}
//                         />
//                       </div>
//                       <div className="flex">
//                         <ButtonTW
//                           variant="success"
//                           onClick={handleCreateEnterprise}
//                           disabled={
//                             isCreatingEnterprise ||
//                             !signupUrlName ||
//                             !enterpriseToken ||
//                             !selectedFile ||
//                             !isCreateEnterpriseEnabled
//                           }
//                         >
//                           Create Enterprise
//                         </ButtonTW>
//                       </div>
//                     </div>

//                     <div className="mt-5 flex justify-end">
//                       <ButtonTW
//                         variant="success"
//                         onClick={handleNextTab}
//                         disabled={!isCreatePoliciesEnabled}
//                       >
//                         Next
//                       </ButtonTW>
//                     </div>

//                     {createEnterpriseError && (
//                       <div className="text-rose-600 text-sm mt-2">
//                         {createEnterpriseError}
//                       </div>
//                     )}
//                   </SectionCard>
//                 )}

//                 {/* STEP 3 */}
//                 {activeVerticalTab === 9 && (
//                   <SectionCard title="Step 3 — Create Policies">
//                     <ul className="space-y-2">
//                       {policies.map((policy) => (
//                         <li key={policy} className="flex items-center gap-2">
//                           {policyCreationStatus[policy] === true ? (
//                             <i className="ri-checkbox-circle-fill text-emerald-600 text-lg" />
//                           ) : policyCreationStatus[policy] === false ? (
//                             <i className="ri-close-circle-fill text-rose-600 text-lg" />
//                           ) : (
//                             <i className="ri-time-line text-amber-500 text-lg" />
//                           )}
//                           <span className="text-sm">{policy}</span>
//                         </li>
//                       ))}
//                     </ul>

//                     <div className="mt-5 flex justify-end">
//                       <ButtonTW
//                         variant="success"
//                         onClick={handleNextTabFromPolicy}
//                         disabled={!isCreatePoliciesEnabled}
//                       >
//                         Next
//                       </ButtonTW>
//                     </div>
//                   </SectionCard>
//                 )}

//                 {/* STEP 4 */}
//                 {activeVerticalTab === 10 && (
//                   <SectionCard title="Step 4 — Create QR">
//                     <div className="flex flex-col items-center justify-center py-4">
//                       {qrCodeUrl ? (
//                         <img
//                           src={qrCodeUrl}
//                           alt="QR Code"
//                           className="w-[200px] sm:w-[250px] h-auto object-contain rounded-xl border border-zinc-200"
//                         />
//                       ) : (
//                         <p className="text-sm text-zinc-500">
//                           QR Code will appear here after successful creation.
//                         </p>
//                       )}
//                     </div>

//                     <div className="flex flex-col sm:flex-row justify-end gap-2">
//                       <ButtonTW
//                         variant="success"
//                         onClick={() => handleAssignEnterpriseConfirmation(false)}
//                         disabled={!qrCodeUrl}
//                       >
//                         Save & Continue
//                       </ButtonTW>
//                       <ButtonTW
//                         variant="success"
//                         onClick={() => handleAssignEnterpriseConfirmation(true)}
//                         disabled={!qrCodeUrl}
//                       >
//                         Set as Default
//                       </ButtonTW>

//                        <ButtonTW
//                           variant="secondary"
//                           onClick={handleSetProvisioningConfirmation}
//                           disabled={!qrCodeUrl}
//                         >
//                           Set Provisioning
//                         </ButtonTW>
//                     </div>
//                   </SectionCard>
//                 )}

//                 {/* STEP 5 */}
//                 {activeVerticalTab === 11 && (
//                   <SectionCard title="Step 5 — Completed">
//                     <div className="text-center py-6">
//                       <div className="mb-4">
//                         <lord-icon
//                           src="https://cdn.lordicon.com/lupuorrc.json"
//                           trigger="loop"
//                           colors="primary:#0ab39c,secondary:#405189"
//                           style={{ width: "120px", height: "120px" }}
//                         ></lord-icon>
//                       </div>
//                       <h5 className="text-lg font-semibold">
//                         Your Enterprise is Completed!
//                       </h5>
//                       <p className="text-sm text-zinc-600 mt-1">
//                         {assignEnterpriseResponse}
//                       </p>
//                     </div>
//                   </SectionCard>
//                 )}
//               </div>
//             </div>

//           </form>
//         </SectionCard>
//       </main>
//     </div>
//   );
// };

// export default FormWizardTesting;
